import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'


export const getListadoArchivos = async(Codigo) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Archivos/getTest/` + Codigo, 'GET')
    return respuesta;
}

export const descargarArchivo = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Archivos/getFile/${Codigo}/${nombre}`, 'GET')
    return respuesta;
}

export const eliminarArchivo = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Archivos/deleteFile/${Codigo}/${nombre}`, 'DELETE')
    return respuesta;
}

export const getLinks = async(IdPurchaseRequest) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Archivos/enlaces/byIdPurchaseRequest/` + IdPurchaseRequest, 'GET')
    return respuesta;
}

export const guardarLink = async(data) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Archivos/enlaces/add`, 'POST', data)
    return respuesta;
}


export const eliminarLink = async (IdLink) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Archivos/enlaces/delete/${IdLink}`, 'DELETE')
    return respuesta;
}